export default {"src":"/_next/static/media/facebook.864a92d3.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};